import React, { useContext } from "react";
import { Button } from "../../../../controls";
import { useNavigate } from "react-router-dom";
import { AppContext } from "App";

const Header = () => {
  const { access } = useContext(AppContext);
  const navigate = useNavigate();

  const handleOrder = () => {
    navigate("/order_stock_form");
  };
  const handleReceive = () => {
    navigate("/receive_stock_form");
  };

  return (
    access?.stock?.create && (
      <div className="flex flex-wrap gap-[10px]">
        <Button onClick={() => handleOrder()}>Order Stock</Button>
        <Button
          onClick={() => handleReceive()}
          variant="text"
          className="!pl-[15px] !pr-[15px]"
        >
          Receive Stock
        </Button>
      </div>
    )
  );
};

export default Header;
